import { createSlice } from '@reduxjs/toolkit';

import { generateDatesBetween} from "../components/UI/Helper";

// Bumped when quote-affecting client logic changes (rates, discounts, airport transfers, etc.).
// index.js compares this to localStorage and forces a hard reload so users do not keep stale bundles/state.
export const RATES_VERSION = '1.0.2';

const initialState = {
  baseAccommodationRate: 2000,
  baseProgramRate: 8000,
  defaultRate: {
    newGuestDiscount: .35,
    returningGuestDiscount: .40
  },
  specialRates: [          
    ...generateDatesBetween('01/11/2025', '30/04/2026').map(date => ({
      name: '35% Discount',
      date: date,
      newGuestDiscount: .35, // Set the new guest discount for June Promotion
      returningGuestDiscount: .40 // Set the returning guest discount for June Promotion
    })),    
    ...generateDatesBetween('01/05/2026', '31/10/2026').map(date => ({
      name: '40% Discount',
      date: date,
      newGuestDiscount: .40, // Set the new guest discount for June Promotion
      returningGuestDiscount: .45 // Set the returning guest discount for June Promotion
    })),   
    ...generateDatesBetween('01/11/2026', '30/04/2027').map(date => ({
      name: '35% Discount',
      date: date,
      newGuestDiscount: .35, // Set the new guest discount for June Promotion
      returningGuestDiscount: .40 // Set the returning guest discount for June Promotion
    })),            
  ]
};

const ratesSlice = createSlice({
  name: 'rates',
  initialState,
  reducers: {}
});

export const ratesActions = ratesSlice.actions;
export default ratesSlice;